import Email from '../../src/legacy/Email';
export default Email;
